module.exports = __webpack_public_path__ + "images/kissing-closed-eyes.png";